import { render, staticRenderFns } from "./AgentGroup.vue?vue&type=template&id=c58e3c84"
import script from "./AgentGroup.vue?vue&type=script&lang=js"
export * from "./AgentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports